import { orderBy } from 'lodash';

import { Action } from '../actions';
import {
    ADD_INTERNAL_PRODUCT,
    CHANGE_INTERNAL_PRODUCT_CELL,
    CHANGE_INTERNAL_PRODUCTS_FORM,
    FETCH_ADD_INTERNAL_PRODUCT,
    FETCH_CHANGE_INTERNAL_PRODUCT,
    FETCH_INTERNAL_PRODUCTS_DATA,
    SEARCH_INTERNAL_PRODUCTS,
    SET_PRODUCTS_PAGE_STATUS,
    SORT_INTERNAL_PRODUCTS,
    UPDATE_INTERNAL_PRODUCT,
    UPDATE_INTERNAL_PRODUCTS_DATA
} from '../actions/products';
import { routeToKeyMap } from '../service/ProductsHelpers';
import {
    Products,
    ProductsListCellItem,
    ProductsPageStates
} from '../typings/products';

export const productsInitialState: Products = {
    products: [],
    filtered: [],
    pageStatus: ProductsPageStates.PENDING,
    productsForm: {
        product: {
            productName: '',
            description: ''
        },
        isValid: true,
        isEnabled: false
    },
    isFiltered: false
};

export function products(
    state: Products = productsInitialState,
    action: Action
): Products {
    switch (action.type) {
        case FETCH_INTERNAL_PRODUCTS_DATA:
            return {
                ...state,
                pageStatus: ProductsPageStates.LOADING
            };

        case UPDATE_INTERNAL_PRODUCTS_DATA:
            return {
                ...state,
                products: action.sortParams
                    ? orderBy<ProductsListCellItem>(
                          action.products.map(item => ({
                              ...item,
                              newDescription: item.description,
                              isEdited: false
                          })),
                          [routeToKeyMap[action.sortParams.key]],
                          [action.sortParams.direction]
                      )
                    : action.products.map(item => ({
                          ...item,
                          newDescription: item.description,
                          isEdited: false
                      })),
                filtered: []
            };

        case ADD_INTERNAL_PRODUCT:
            const newProduct: ProductsListCellItem = {
                ...action.product,
                newDescription: action.product.description,
                isEdited: false
            };

            return {
                ...state,
                products: action.sortParams
                    ? orderBy<ProductsListCellItem>(
                          [...state.products, newProduct],
                          [routeToKeyMap[action.sortParams.key]],
                          [action.sortParams.direction]
                      )
                    : [...state.products, newProduct],
                filtered: [],
                isFiltered: false
            };

        case SET_PRODUCTS_PAGE_STATUS:
            return {
                ...state,
                pageStatus: action.status
            };

        case FETCH_CHANGE_INTERNAL_PRODUCT:
            return {
                ...state,
                pageStatus: ProductsPageStates.ACTION
            };

        case UPDATE_INTERNAL_PRODUCT:
            return {
                ...state,
                products: state.products.map(item => {
                    if (item.id === action.product.id) {
                        return {
                            ...action.product,
                            newDescription: action.product.description,
                            isEdited: false
                        };
                    }

                    return item;
                }),
                filtered: state.filtered.map(item => {
                    if (item.id === action.product.id) {
                        return {
                            ...action.product,
                            newDescription: action.product.description,
                            isEdited: false
                        };
                    }

                    return item;
                })
            };

        case SORT_INTERNAL_PRODUCTS:
            return {
                ...state,
                products: orderBy<ProductsListCellItem>(
                    [...state.products],
                    [routeToKeyMap[action.sortParams.key]],
                    [action.sortParams.direction]
                ),
                filtered: orderBy<ProductsListCellItem>(
                    [...state.filtered],
                    [routeToKeyMap[action.sortParams.key]],
                    [action.sortParams.direction]
                )
            };

        case FETCH_ADD_INTERNAL_PRODUCT:
            return {
                ...state,
                pageStatus: ProductsPageStates.FETCH_FORM
            };

        case CHANGE_INTERNAL_PRODUCTS_FORM:
            return {
                ...state,
                productsForm: action.form
            };

        case CHANGE_INTERNAL_PRODUCT_CELL:
            return {
                ...state,
                products: state.products.map(item => {
                    if (item.id === action.product.id) {
                        return action.product;
                    }

                    return item;
                }),
                filtered: state.filtered.map(item => {
                    if (item.id === action.product.id) {
                        return action.product;
                    }

                    return item;
                })
            };

        case SEARCH_INTERNAL_PRODUCTS:
            return {
                ...state,
                filtered: state.products.filter(product => {
                    return product.productName
                        .toUpperCase()
                        .includes(action.searchInput.toUpperCase());
                }),
                isFiltered: !!action.searchInput
            };

        default:
            return state;
    }
}
